export default "__VITE_ASSET__BbHaFZ79__"